import React from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import './index.scss';

export interface IMentionDropdownSectionTitleProps {
  /** 国际化 key */
  titleId: string;
  className?: string;
}

/** Mention 下拉面板顶部固定标题 */
const MentionDropdownSectionTitle: React.FC<IMentionDropdownSectionTitleProps> = ({
  titleId,
  className,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classNames('dba-mention-dropdown-section-title', className)}>
      {formatMessage({ id: titleId })}
    </div>
  );
};

export default MentionDropdownSectionTitle;
